[
  {
    "value": "dkk",
    "label": "DKK"
  },
  {
    "value": "nok",
    "label": "NOK"
  },
  {
    "value": "sek",
    "label": "SEK"
  },
  {
    "value": "eur",
    "label": "EUR"
  },
  {
    "value": "usd",
    "label": "USD"
  },
  {
    "value": "gbp",
    "label": "GBP"
  }
]